export default {
  model: {
    type: {
      notes: 'Type property of feedback',
      message: 'Type of feedback',
      values: {
        bug: {
          notes: 'Label for feedback type "bug"',
          message: 'Bug',
        },
        feature: {
          notes: 'Label for feedback type "feature"',
          message: 'Feature request',
        },
        data: {
          notes: 'Label for feedback type "data issue"',
          message: 'Data issue',
        },
        usability: {
          notes: 'Label for feedback type "usability"',
          message: 'Usability issue',
        },
        general: {
          notes: 'Label for feedback type "general"',
          message: 'General feedback',
        },
      },
    },
    feedback: {
      notes: 'Feedback text property of feedback',
      message: 'Feedback',
    },
    contactApproval: {
      notes: 'Contact approvals property of feedback',
      message: "I'd like to be contacted",
    },
  },
  dialog: {
    header: {
      notes: 'Header for feedback dialog',
      message: 'Submit feedback',
    },
  },
  action: {
    openDialog: {
      notes: 'Label for action to open use feedback dialog',
      message: 'Submit feedback',
    },
    submit: {
      notes: 'Label for submit feedback button',
      message: 'Submit',
    },
  },
  thankYou: {
    notes: 'Message displayed after feedback is submitted successfully',
    message:
      "Thank You! We appreciate your feedback. If you requested contact, we'll be in touch soon. Thank you for helping us make SAM better!",
  },
};
